<template>
  <div class="ui segment">
    <div class="ui form">
      <h4>Reservation Info</h4>
      <div class="field">
        <label>Pickup</label>
        <p>{{ reservation.pickup.formatted }}</p>
      </div>

      <div class="field">
        <label>Dropoff</label>
        <p>{{ reservation.dropoff.formatted }}</p>
      </div>

      <div class="field">
        <label>Requested Vehicle Type</label>
        <p>{{ getVehicleType() }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Summary',
    props: ['reservation'],
    methods: {
      getVehicleType: function () {
        if ('selectedQuote' in this.reservation) {
          return this.reservation.selectedQuote.vehicleName
        } else {
          return ''
        }
      }
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Summary.vue